import request from '../services/request';

export function search(data) {
  return request({
    url: `/recognition/search`,
    method: 'POST',
    data,
  });
}

export function searchRecognitions(data, page) {
  return request({
    url: `/recognition/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function storeRecognition(data) {
  return request({
    url: `/recognition`,
    method: 'POST',
    data,
  });
}

export function statusRecognition(id, data) {
  return request({
    url: `/recognition/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function updateRecognition(id, data) {
  return request({
    url: `/recognition/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteRecognition(id) {
  return request({
    url: `/recognition/${id}`,
    method: 'DELETE',
  });
}

export function getRecognitionById(id, data) {
  return request({
    url: `/recognition/${id}`,
    method: 'GET',
    data,
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/recognition/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function resetRecognition(id) {
  return request({
    url: `/recognition/${id}/reset`,
    method: 'GET',
  });
}

export function syncRecognition(id) {
  return request({
    url: `/recognition/${id}/sync`,
    method: 'GET',
  });
}

export function rebootRecognition(id) {
  return request({
    url: `/recognition/${id}/reboot`,
    method: 'GET',
  });
}

export function getAnalyticsRecognition(data) {
  return request({
    url: `/recognition/dashboard/analytics`,
    method: 'POST',
    data,
  });
}

export function catalogAccessTypes() {
  return request({
    url: `/recognition/catalog/access-type`,
    method: 'GET',
  });
}
// -------------- Catalogos para combobox ------------------------

export function catalogCompanies() {
  return request({
    url: `/recognition/catalog/companies`,
    method: 'GET',
  });
}

export function catalogLocations(data) {
  return request({
    url: `/recognition/catalog/locations`,
    method: 'POST',
    data,
  });
}

export function catalogBuildings(data) {
  return request({
    url: `/recognition/catalog/building`,
    method: 'POST',
    data,
  });
}

export function catalogZones(data) {
  return request({
    url: `/recognition/catalog/zone`,
    method: 'POST',
    data,
  });
}

export function catalogBrands() {
  return request({
    url: `/recognition/catalog/brand`,
    method: 'GET',
  });
}

export function catalogModels() {
  return request({
    url: `/recognition/catalog/model`,
    method: 'GET',
  });
}
